import { AlertType } from '@components/Feedback/Alert/styles';

export interface LoginBody {
    errors?: AuthError[];
    changePasswordId?: string;
    theme?: string;
    twoFactorId?: string;
    mfaMethods?: string[];
}

export interface LoginResponse {
    response: Response;
    body: LoginBody;
}

export interface VerifyMfaBody {
    userId?: string;
    theme?: string;
    errors?: AuthError[];
}

export interface VerifyMfaResponse {
    response: Response;
    body: VerifyMfaBody;
}

export const authenticationStatus = {
    200: 'LoggedIn',
    202: 'MfaRequired',
    203: 'UpdatePassword',
    401: 'Unauthorized',
    403: 'Forbidden',
    404: 'Unauthorized',
    500: 'InternalError',
    0: 'UnknownError',
    1: 'Loading',
} as const;

export type AuthenticationStatus = typeof authenticationStatus[keyof typeof authenticationStatus];

export interface AuthError {
    message: string;
    type?: AlertType;
}

export const UserRoles = {
    groupOwner: 'group_owner',
    developer: 'developer',
    openPlatformDeveloper: 'open_platform_developer',
    organisationOwner: 'organisation_owner',
};
